module.exports = __webpack_public_path__ + "static/media/marketing-vote.cb470af4.png";